import React, { Component } from 'react';
import {Alert, Button, ButtonGroup, Col, Row} from "react-bootstrap";
import FieldGroup from "../FieldGroup";
import {saveCustomer, getCustomer} from "../../redux/actions";
import {connect} from "react-redux";
import {withRouter} from "react-router-dom";
import {CREATE_MODE, EDIT_MODE, VIEW_MODE} from "../constants";

import {authorised} from "../layout/authorised";

class CustomerDetails extends Component {
    constructor(props) {
        super(props);

        this.id = props.match.params.id;
        this.state = {
            mode: typeof props.mode !== "undefined" ? props.mode : VIEW_MODE,
            emptyCustomer: true,
            customer: typeof this.props.customer !== "undefined" ? this.props.customer : {
                name: "",
                customerNumber: "",
                address: {
                    city: "",
                    address: ""
                },
                configuration:{
                    privateCore: {
                        dns: "",
                        httpPort: 80,
                        httpsEnabled: true
                    }
                }
            }
        };

        if(this.state.mode !== CREATE_MODE) {
            this.props.dispatch(getCustomer(this.id))
        }
    }

    componentDidUpdate() {
        if(this.state.emptyCustomer && this.props.customer) {
            this.setState({ customer: this.props.customer, emptyCustomer:false})
        }

        if(this.state.saving === true && this.props.pendingCalls === 0) {
            // Check if there was an error.
            this.setState({saving: false});
            if(!this.props.error) {
                this.props.history.push('/')
            }
        }
    }

    nameChanged(e) {
        this.setState({customer: {...this.state.customer, name: e.target.value}, error: undefined});
    }

    customerNumberChanged(e) {
        this.setState({customer: {...this.state.customer, customerNumber: e.target.value}, error: undefined});
    }

    cityChanged(e) {
        this.setState({
            customer: {
                ...this.state.customer,
                address: {...this.state.customer.address, city: e.target.value}
            },
            error: undefined
        });
    }

    addressChanged(e) {
        this.setState({
            customer: {
                ...this.state.customer,
                address: {...this.state.customer.address, address: e.target.value}
            },
            error: undefined
        });
    }

    privateCoreDnsChanged(e) {
        this.setState({
            customer: {
                ...this.state.customer, configuration: {
                    ...this.state.customer.configuration, privateCore: {
                        ...this.state.customer.configuration.privateCore,
                        dns: e.target.value
                    }
                }
            },
            error: undefined
        });
    }

    privateCoreHttpPortChanged(e) {
        let s = e.target.value.trim();
        let port = parseInt(s, 10);
        if(isNaN(port)) {
            port = "";
        }

        this.setState({
            customer: {
                ...this.state.customer, configuration: {
                    ...this.state.customer.configuration, privateCore: {
                        ...this.state.customer.configuration.privateCore,
                        httpPort: port
                    }
                }
            },
            error: undefined
        });
    }

    privateCoreHttpsEnabledChanged(e) {
        this.setState({
            customer: {
                ...this.state.customer, configuration: {
                    ...this.state.customer.configuration, privateCore: {
                        ...this.state.customer.configuration.privateCore,
                        httpsEnabled: e.target.checked
                    }
                }
            },
            error: undefined
        });
    }

    isDisabled() {
        return this.state.mode === VIEW_MODE;
    }

    startEdit(e) {
        e.preventDefault();
        this.setState({mode: EDIT_MODE});
    }

    loginOnPrivateCore(e) {
        e.preventDefault();
        this.props.history.push('/customers/'+this.id+"/private/login");
    }

    goToPrivateCore(e) {
        e.preventDefault();
        this.props.history.push('/customers/'+this.id+"/private");
    }

    updateCustomer(e) {
        this.setState({saving: true});
        e.preventDefault();
        this.props.dispatch(saveCustomer({customer: this.state.customer, mode: this.state.mode}));
    }

    isLoggedIn() {
        return typeof this.props.privateCoreJwt[this.id] !== "undefined";
    }

    render() {
        return (
            <div>
                <Row className="show-grid">
                    <Col xsHidden={true} smHidden={true} md={3} lg={4} />
                    <Col xs={12} sm={12} md={6} lg={4}>
                        <h2>{this.state.customer ? this.state.customer.name: null } </h2>
                        {this.state.customer ? <form>
                            <FieldGroup
                                value={this.state.customer.name}
                                id="customer_name"
                                type="text"
                                disabled={this.isDisabled()}
                                onChange={e => this.nameChanged(e)}
                                label="Name"
                                placeholder="Customer name"
                            />

                            <FieldGroup
                                value={this.state.customer.customerNumber}
                                id="customer_number"
                                type="text"
                                disabled={this.isDisabled()}
                                onChange={e => this.customerNumberChanged(e)}
                                label="Customer number"
                                placeholder="Customer number"
                            />

                            <FieldGroup
                                value={this.state.customer.address.city}
                                id="customer_address_city"
                                type="text"
                                disabled={this.isDisabled()}
                                onChange={e => this.cityChanged(e)}
                                label="City"
                                placeholder="City"
                            />

                            <FieldGroup
                                value={this.state.customer.address.address}
                                id="customer_address_address"
                                type="text"
                                disabled={this.isDisabled()}
                                onChange={e => this.addressChanged(e)}
                                label="Address"
                                placeholder="Address"
                            />

                            <FieldGroup
                                value={this.state.customer.configuration.privateCore.dns}
                                id="private_core_dns"
                                type="text"
                                disabled={this.isDisabled()}
                                onChange={e => this.privateCoreDnsChanged(e)}
                                label="Private core DNS"
                                placeholder="mycustomer.kateinnovations.com"
                            />

                            <FieldGroup
                                value={this.state.customer.configuration.privateCore.httpPort}
                                id="private_core_http_port"
                                type="number"
                                disabled={this.isDisabled()}
                                onChange={e => this.privateCoreHttpPortChanged(e)}
                                label="HTTP port"
                                placeholder="80"
                            />


                            <FieldGroup
                                checked={this.state.customer.configuration.privateCore.httpsEnabled}
                                id="private_core_https_enabled"
                                type="checkbox"
                                disabled={this.isDisabled()}
                                onChange={e => this.privateCoreHttpsEnabledChanged(e)}
                                label="HTTPs enabled"
                                placeholder="80"
                            />

                            { typeof this.props.error !== 'undefined' ?
                                <Alert bsStyle="danger">
                                    { this.props.error }
                                </Alert> : null }

                                {this.isDisabled() ?
                                    <ButtonGroup>
                                        <Button onClick={e => this.startEdit(e)}>Edit</Button>
                                        { this.isLoggedIn() ?
                                            <Button onClick={e => this.goToPrivateCore(e)}>Logged in</Button> :
                                            <Button onClick={e => this.loginOnPrivateCore(e)}>Login</Button>
                                        }

                                    </ButtonGroup>
                                    :
                                    <Button block={true} disabled={this.props.pendingCalls > 0}
                                            onClick={e => this.updateCustomer(e)} bsStyle="primary"
                                            type="submit">Save</Button>}

                        </form> : null }
                    </Col>
                </Row>
            </div>
        );
    }
}

const mapStateToProps = state => {
    return { customer: state.currentCustomer, pendingCalls: state.pendingCalls, error: state.lastError, privateCoreJwt: state.privateCoreJwt };
};

const mapDispatchToProps = (dispatch) => ({dispatch});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(authorised(CustomerDetails)));



// WEBPACK FOOTER //
// ./src/components/customer/CustomerDetails.js